import {h, Fragment} from "preact"
import Products from "./Products"
import Toolbar from "./Toolbar"
import Sidebar from "./Sidebar"
import { wrapContent } from "./ContentWrapper"
import { InfiniteScroll } from "@nosto/preact"
import Loader from "./elements/Loader"
import NoResults from "./NoResults"
import { useState } from "preact/hooks"

export function SerpBody({ loading, foundProducts }) {
    if (loading) return <Loader />
    return (
        foundProducts ? <>
            <Toolbar />
            <Products />
        </> : <>
            <Toolbar />
            <NoResults />
        </>
    )
}

export function SerpBodyInfiniteScroll({ loading, foundProducts }) {
    const [ singleViewMobile, setSingleViewMobile ] = useState(false)
    if (!foundProducts) return loading ? <Loader /> : <NoResults />
    return (
        <>
            <Sidebar />
            <div class="ns-serp-inner">
                <Toolbar singleViewMobile={singleViewMobile} setSingleViewMobile={setSingleViewMobile} />
                <InfiniteScroll>
                    <Products singleViewMobile={singleViewMobile} />
                </InfiniteScroll>
            </div>
        </>
    )
}

// replace with following line to enable infinite scroll
export default wrapContent("search", SerpBodyInfiniteScroll)
// export default wrapContent("search", SerpBody)
